import { cn } from "@/lib/cn";

export function RadialBackground({
  className,
  variant = "light",
}: {
  className?: string;
  variant?: "light" | "dark" | "accent";
}) {
  const stroke =
    variant === "dark"
      ? "rgba(255,255,255,0.06)"
      : variant === "accent"
        ? "rgba(0,0,0,0.08)"
        : "rgba(0,0,0,0.05)";

  const lines = Array.from({ length: 36 }, (_, i) => i);

  return (
    <div
      aria-hidden="true"
      className={cn(
        "pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden",
        className,
      )}
    >
      <svg
        viewBox="-500 -500 1000 1000"
        className="h-[160%] w-[160%] max-w-none"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <radialGradient id="rayFade" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor={stroke} stopOpacity="0.9" />
            <stop offset="60%" stopColor={stroke} stopOpacity="0.5" />
            <stop offset="100%" stopColor={stroke} stopOpacity="0" />
          </radialGradient>
          <mask id="rayMask">
            <rect x="-500" y="-500" width="1000" height="1000" fill="url(#rayFade)" />
          </mask>
        </defs>
        <g mask="url(#rayMask)" stroke={stroke} strokeWidth="1">
          {lines.map((i) => (
            <line
              key={i}
              x1="0"
              y1="0"
              x2="0"
              y2="-700"
              transform={`rotate(${(360 / lines.length) * i})`}
            />
          ))}
        </g>
        <g stroke={stroke} strokeWidth="1" fill="none" opacity="0.8">
          <circle r="120" />
          <circle r="220" />
          <circle r="340" />
          <circle r="460" />
        </g>
      </svg>
    </div>
  );
}
